import React, { useState } from 'react'
import { Editor } from '@tinymce/tinymce-react'
import { Storage } from '@aws-amplify/storage'
import { Box, CircularProgress, Typography } from '@mui/material'

const TinyEditorComponent = React.forwardRef((props, ref) => {
  const { setValue, value, name, disabled = false, charLimit } = props
  const [initialized, setInitialized] = useState(false)

  return (
    <>
      {!initialized && (
        <Box display='flex' flexDirection='row' gap={2} alignItems='center'>
          <CircularProgress size={18} color='primary' />
          <Typography>
            Loading tinyme editor, please wait...
          </Typography>
        </Box>
      )}
      <Box sx={{ visibility: initialized ? 'visible' : 'hidden', height: !initialized && 0 }}>
        <Editor
          tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
          onInit={(evt, editor) => {
            setInitialized(true)
            if (ref) {
              ref.current = editor
            }
          }}
          disabled={disabled}
          onEditorChange={(ev, editor) => {
            if (charLimit) {
              const charCount = editor.plugins.wordcount.body.getCharacterCount()
              if (charCount <= charLimit) {
                setValue(name, ev)
              } else {
                return false
              }
            } else {
              setValue(name, ev) // Normal behavior for other fields
            }
          }}
          value={value}
          init={{
            promotion: false,
            height: 'auto',
            plugins: [
              'preview',
              'importcss',
              'searchreplace',
              'autolink',
              'autosave',
              'save',
              'directionality',
              'code',
              'visualblocks',
              'visualchars',
              'fullscreen',
              'image',
              'link',
              'media',
              'template',
              'codesample',
              'table',
              'charmap',
              'nonbreaking',
              'anchor',
              'insertdatetime',
              'advlist',
              'lists',
              'wordcount',
              'help',
              'charmap',
              'emoticons',
              'accordion',
              'autoresize'
            ],
            menubar: 'file edit view insert format tools table help',
            toolbar: `
            undo redo | 
            blocks fontsize | 
            bold italic underline strikethrough | 
            link image | 
            table media | 
            align numlist bullist | 
            lineheight outdent indent| 
            forecolor backcolor removeformat | 
            charmap emoticons | 
            code fullscreen preview |
            anchor codesample | 
            ltr rtl
            `,
            templates: [
              {
                title: 'Menu with icon and description',
                description: 'Paragraph sections',
                content: `
              <div style="display: flex; flex-direction: column; gap: 16px;">
                <div style="display: flex; flex-direction: row; gap: 16px; align-items: center;">
                <img src="https://nova-dev-content.s3.eu-west-2.amazonaws.com/public/building.png-1698239699962.png" alt="" width="40" height="40" />
                <h2>Template icon title</h2>
                </div>
                <p>Lorem ipsum dolor sit amet consectetur. <br>Pellentesque pulvinar ipsum tellus elementum magna ac. Arcu nunc malesuada odio purus. Nec tellus sollicitudin velit a nibh purus in. Interdum nunc vitae ornare aliquam. Dolor duis habitasse amet vitae sed felis.</p>
              </div>
              `
              },
              {
                title: 'Date modified example',
                description: 'Adds a timestamp indicating the last time the document modified.',
                content: '<p>Last Modified: <time class="mdate">This will be replaced with the date modified.</time></p>'
              }
            ],
            valid_children: '+body[style]',
            default_link_target: '_blank',
            content_style: 'body { font-family:"Libre Franklin", Roboto,Helvetica,Arial,sans-serif; font-size:16px }',
            image_uploadtab: true,
            font_size_formats: '8px 10px 12px 14px 16px 18px 24px 36px',
            image_advtab: true,
            automatic_uploads: true,
            imagetools_cors_hosts: ['amazonaws.com'],
            imagetools_credentials_hosts: ['amazonaws.com'],
            images_upload_handler: async function (blobInfo, progress) {
              const file = blobInfo.blob()
              const fileName = blobInfo.filename()
              const fileExt = fileName.split('.').pop()
              const fileKey = `${fileName}-${Date.now()}`
              const filePath = `${fileKey}.${fileExt}`
              await Storage.put(filePath, file, {
                progressCallback: _progress => progress(_progress.loaded / _progress.total * 100)
              })

              const imgixUrl = `${process.env.REACT_APP_IMGIX_URL}/${filePath}`

              return imgixUrl
            }
          }}
        />
      </Box>
    </>
  )
})

export default TinyEditorComponent
